/**
 * @description 取得可用查詢條件用
*/
export enum QClass {
    /** 保單查詢 */
    FILTER_FEMP = 'FILTER_FEMP'
}

/**
 * @description 查詢選項共用預設值
*/
export enum InquiryDefault {
    SELECT_ALL = 'A',
    PAGE = 1,
    PAGE_SIZE = 10
}

/**
 * @description 取得可用查詢條件-欄位代號用
 */
export enum FID {
    /** 生效日期(起) */
    SDATE_S = 'SDATE_S',
    /** 生效日期(迄) */
    SDATE_E = 'SDATE_E',
    /** 險種 */
    INS_TYPE_ID = 'INS_TYPE_ID',
        /** 保單狀態 */
    POLICY_STATUS = 'POLICY_STATUS',
    /** 查詢 */
    QUERY = 'QUERY'
}

/**
 * @description 取得可用查詢條件-欄位型態用
 */
export enum FTYPE {
    /** 日期區間 */
    DATEPERIOD = 'DATEPERIOD',
    /** 下拉式選單 */
    SELECT = 'SELECT',
    /** 文字 */
    TEXT = 'TEXT',
    /** 單選項 */
    SINGLE = 'SINGLE',
    /** 複選項 */
    MULTIPLE = 'MULTIPLE',
    /** 查詢 API URL */
    QUERYURL = 'QUERYURL'
}

/**
 * @description 我要辦理項目
*/
export enum HandleType {
    /** 明細 */
    Detail = 'D',
    /** 批改 */
    Modify = 'M',
    /** 續保 */
    RePolicy = 'R'
}

/**
 * @description 我要辦理項目
*/
export enum HandleTypeText {
    /** 明細 */
    Detail = '明細',
    /** 批改 */
    Modify = '批改',
    /** 續保 */
    RePolicy = '續保'
}

/**
 * @description 明細查詢 REF_FROM 參數使用
*/
export enum RefFrom {
    /** 明細頁用 */
    Detail = '2',
}

/**
 * @description 是否快速理賠
*/
export enum QuickClaim {
    YES = '1',
    NO = '0'
}
